"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReturnsCSV = getReturnsCSV;
const papaparse_1 = require("papaparse");
const utils_1 = require("../utils");
function getReturnsCSV(returns, scanCenter) {
    return (0, papaparse_1.unparse)((0, utils_1.getReturnsByScanCenter)(returns, scanCenter), {
        delimiter: ';',
        quotes: true,
    });
}
//# sourceMappingURL=get-returns-csv.js.map